import React, { useState } from 'react';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import ModalBody, { ModalProps } from '../../ModalBody';
import { useDuplicateActivityToDateMutation } from '../../../../hooks/mutations/useActivityMutation';

interface DuplicateActivityModalProps extends ModalProps {
    activityId: string;
    initialDate?: Date;
    name?: string;
}

const DuplicateActivityModal: React.FC<DuplicateActivityModalProps> = ({ activityId, initialDate = new Date(), open, handleClose, name }) => {
    const { t } = useTranslation();
    const [selectedDate, setSelectedDate] = useState<Date>(initialDate);

    const mutation = useDuplicateActivityToDateMutation({
        onSuccess: () => {
            handleClose();
        },
    });

    const handleOk = () => {
        mutation.mutate({
            activityId,
            body: { targetDate: selectedDate.toISOString() },
        });
    };

    return (
        <ModalBody
            title={t('activity')}
            subTitle={t('duplicate')}
            description={name}
            closeText={t('cancel')}
            okText={t('validate')}
            open={open}
            handleClose={handleClose}
            handleOk={handleOk}
            oKloading={mutation.isLoading}
            
        >
            <div className="fx-c">
                <DateCalendar
                    onChange={(value) => {
                        if (value) setSelectedDate(new Date(value.toISOString()));
                    }}
                    value={dayjs(selectedDate)}
                    displayWeekNumber
                />
            </div>
        </ModalBody>
    );
};

export default DuplicateActivityModal;
